import { StyleSheet } from 'aphrodite';
import { BreakPoints } from '../../../../web/styles/styles';

export const styleSheet = StyleSheet.create({
	configureSchedule: {
		boxSizing: 'border-box',
		padding: 20,
	},
	container: {},
	recipients: {},
	recipientsContainer: {
		boxSizing: 'border-box',
		display: 'flex',
		height: '100%',
		paddingTop: 32,
		[BreakPoints.tabletCompactHeight]: {
			paddingTop: 30,
		},
	},
});
